import { Password } from 'primereact/password';

export interface BasePasswordProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  name?: string;
  placeholder?: string;
  invalid?: boolean;
  disabled?: boolean;
  autoComplete?: 'current-password' | 'new-password' | 'off';
  autoFocus?: boolean;
  maxLength?: number;
  inputMode?: 'numeric' | 'text';
}

/** Password field with a show/hide toggle. Never upper-cased. */
export function BasePassword({
  id,
  value,
  onChange,
  onBlur,
  name,
  placeholder,
  invalid,
  disabled,
  autoComplete = 'current-password',
  autoFocus,
  maxLength,
  inputMode,
}: BasePasswordProps) {
  return (
    <Password
      inputId={id}
      name={name ?? id}
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      onBlur={onBlur}
      placeholder={placeholder}
      invalid={invalid}
      disabled={disabled}
      feedback={false}
      toggleMask
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      maxLength={maxLength}
      inputMode={inputMode}
      aria-invalid={invalid ? true : undefined}
      aria-describedby={invalid ? `${id}-error` : undefined}
      className="nocaps w-full"
      inputClassName="w-full nocaps"
    />
  );
}
